import { Tag } from 'antd';
import styled from 'styled-components';

export const CustomBadgeWrapper = styled(Tag)<{ background?: string }>`
  max-width: 100%;
  width: fit-content;
  padding: 4px 12px;
  border-radius: 16px;
  position: relative;
  margin-inline: 0;
  font-weight: 600;

  display: flex;
  align-items: center;

  text-wrap: wrap;

  border-color: ${props => props.background};
  background: white;

  color: ${props => props.background};

  &.fullWidth {
    width: 100%;
    justify-content: center;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    border-radius: 14px;
    opacity: 0.1;
    background: ${props => props.background};
  }

  &.primary-type .ant-space-item {
    color: white;
  }

  &.primary-type::before {
    opacity: 1;
  }

  &.large {
    height: 44px;

    .ant-space-item {
      font-size: 16px;
    }
  }

  &.middle {
    min-height: 32px;

    .ant-space-item {
      font-size: 14px;
    }
  }

  &.small {
    height: 28px;

    .ant-space-item {
      font-size: 12px;
    }
  }

  .ant-space {
    position: relative;
    height: 100%;
    // padding-bottom: 1px;

    .ant-space-item {
      word-break: break-word;
    }
  }
`;
